import React from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import { UxContext } from '@client/context/UxContext';
import i18n from '@client/utils/i18n';
import lediumApi from '@client/utils/lediumApi';
import { Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const defaultFormData = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
};

function UserTab() {
    const { handleSnackbar } = React.useContext(UxContext)!;

    const [formData, setFormData] = React.useState(defaultFormData);
    const [passwdChangeEnabled, setPasswdChangeEnabled] = React.useState(false);

    React.useEffect(() => {
        setPasswdChangeEnabled(!!(formData.currentPassword && formData.newPassword && formData.newPassword === formData.confirmPassword));
    }, [formData]);

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        const name = event.target.name;
        setFormData({ ...formData, ...{ [name]: event.target.value } });
    }

    function onSubmit() {
        lediumApi.post<{ auth?: boolean; success?: boolean }>('users/changePassword', formData).then((data) => {
            if (data?.auth === false) {
                handleSnackbar({ message: i18n('password_incorrect') as string, severity: 'error' });
            }
            if (data?.success === true) {
                handleSnackbar({ message: i18n('password_changed') as string });
                setFormData(defaultFormData);
            }
        });
    }

    return (
        <ValidatorForm onSubmit={onSubmit}>
            <Grid container spacing={3} sx={{ marginTop: '20px' }}>
                <Grid item xs={12}>
                    <Typography variant="h2">{i18n('change_password')}</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: '4px' }}>
                        {i18n('change_password_description')}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextValidator
                        fullWidth
                        label={i18n('current_password')}
                        type="password"
                        variant="outlined"
                        name="currentPassword"
                        onChange={handleChange}
                        value={formData.currentPassword}
                        validators={['required']}
                        errorMessages={[i18n('this_field_is_required')]}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextValidator
                        fullWidth
                        label={i18n('new_password')}
                        type="password"
                        variant="outlined"
                        name="newPassword"
                        onChange={handleChange}
                        value={formData.newPassword}
                        validators={['required']}
                        errorMessages={[i18n('this_field_is_required')]}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextValidator
                        fullWidth
                        label={i18n('confirm_password')}
                        type="password"
                        variant="outlined"
                        name="confirmPassword"
                        onChange={handleChange}
                        value={formData.confirmPassword}
                        validators={['required']}
                        errorMessages={[i18n('this_field_is_required')]}
                    />
                </Grid>

                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                    <Button disabled={!passwdChangeEnabled} variant="contained" color="primary" type="submit">
                        {i18n('change_password')}
                    </Button>
                </Grid>
            </Grid>
        </ValidatorForm>
    );
}

export default UserTab;
